import React, { useEffect, useState } from "react";
import Navbar from '../../Componenets/Navbar'
import { useSelector , useDispatch } from "react-redux";
import { fetchUser, updateUser} from "../../Redux/User/userSlice";
import Loader from '../../Componenets/Loader'
import toast, { Toaster } from 'react-hot-toast';
import {fetchOrders} from "../../Redux/Order/orderSlice";
import { imageUrl } from "../../Config";


const ProfilePage = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("favorites");
  const {user : profile} = useSelector((state)=>state.user);
  useEffect(()=>{
    dispatch(fetchOrders())
  },[])

  const {orders} = useSelector((state)=>state.order)
  const favorites = useSelector((state) => state.favorites.items);

  const [formData, setFormData] = useState({
    first_name: profile?.name || "",
    last_name : profile?.last_name || '',
    email : profile?.email || '',
    phone: profile?.phone || "",
    country: profile?.country || "",
    state: profile?.state || "",
    city: profile?.city || "",
    address: profile?.address || "",
    zip_code: profile?.zip_code || "",
  });

  useEffect(()=>{
    if(profile){
        setFormData({
          first_name: profile?.first_name || "",
          last_name : profile?.last_name || '',
          email : profile?.email || '',
          phone: profile?.phone || "",
          country: profile?.country || "",
          state: profile?.state || "",
          city: profile?.city || "",
          address: profile?.address || "",
          zip_code: profile?.zip_code || "",
          })
    }
  },[profile])
  console.log(formData)
  const {loading} = useSelector((state)=>state.user)

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Updated Profile Data:", formData);
    try {
        dispatch(updateUser(formData));
        toast.success("Profile updated!");
        } catch (error) {
        alert('Error occurred while updating profile' , error.message)
    }
    dispatch(fetchUser())
    
  };


  return (
    <div className="container-fluid d-flex justify-content-center align-items-center vh-100">
        <Toaster />
        
        {loading && <Loader />}
      <div className="row shadow-lg rounded-4" style={{ width: "80%", background: "#fff", height: "80%" , marginTop : '5%'}}>

        {/* Sidebar Navigation */}
        <div className="col-md-3 p-3" style={{ background: "#b3697b", borderRadius: "15px 0 0 15px" }}>
          <h4 className="text-white text-center mb-4">My Account</h4>
          <ul className="nav flex-column">
            <li className="nav-item">
              <button className={`nav-link w-100 text-white ${activeTab === "favorites" ? "active-tab" : ""}`} onClick={() => setActiveTab("favorites")}>
                Favorites
              </button>
            </li>
          </ul>
        </div>

        {/* Main Content */}
        <div className="col-md-9 p-4 d-flex flex-column" style={{ height: "100%", overflowY: "scroll" }}>
          <div className="tab-content" >

            {activeTab === "favorites" && (
              <div>
                <h4 className="mb-3 text-center" style={{ color: "#b3697b" }}>Favorite Items</h4>
                {favorites?.map((item) => (
                  <div key={item.id} className="d-flex align-items-center border p-2 mb-2 rounded">
                    <img src={imageUrl+item.imageUrl} alt={item.name} className="rounded" width="50" />
                    <div className="ms-3">
                      <p className="mb-1">{item.name}</p>
                      <p className="text-primary fw-bold">${item.price}</p>
                    </div>
                  </div>
                ))}
                {favorites.length == 0 && (
                  <h5 className="d-flex justify-content-center">
                    You have no favorite items yet. Click on the heart icon to add an item to your favorites
                  </h5>
                )}
              </div>
            )}

          </div>
        </div>
        <style>{`
        .nav-link {
          padding: 10px;
          transition: 0.3s;
          font-size: 16px;
          border-radius: 8px;
        }
        .nav-link:hover {
          background: rgba(255, 255, 255, 0.2);
        }
        .active-tab {
          background: white !important;
          color: #f5a3b7 !important;
          font-weight: bold;
        }
      `}</style>

      </div>
    </div>
  );
};

export default ProfilePage;
